import * as z from 'zod';

import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';
import { statusQuerySchema } from '@/_schemas/status-input';

export const recruitingStatusQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string(),
});
export type RecruitingStatusQueryLinkerSchema = z.infer<typeof recruitingStatusQueryLinkerSchema>;

export const recruitingStatusQuerySchema = z.object({
  ...recruitingStatusQueryLinkerSchema.shape,
  status: statusQuerySchema,
});

export type RecruitingStatusQuerySchema = z.infer<typeof recruitingStatusQuerySchema>;

export const recruitingStatusQueryAllSchema = paginatedResponseSchema(recruitingStatusQuerySchema);
export type RecruitingStatusQueryAllSchema = z.infer<typeof recruitingStatusQueryAllSchema>;
